<mat-form-field class="account-selector" appearance="outline">
  <mat-label>
    {{ 'CAMPAIGN_GENERIC.TEST_EMAIL.PREVIEW_AS' | translate }}
  </mat-label>
  <input
    type="text"
    matInput
    placeholder="{{ 'LISTS.CAMPAIGN_DIALOG.DEFAULT_ACCOUNT.SEARCH_SELECT_ACCOUNT' | translate }}"
    [formControl]="accountGroupSelect"
    [matAutocomplete]="auto"
    (input)="updateSearchTerm($event)"
  />
  <mat-autocomplete
    class="account-autocomplete"
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="selectAccount($event.option.value)"
  >
    <mat-option class="account-option" [value]="genericAccountGroup">
      {{ 'CAMPAIGN_GENERIC.TEST_EMAIL.GENERIC_ACCOUNT' | translate }}
    </mat-option>
    <mat-option *ngFor="let accountGroup of accountGroups$ | async" class="account-option" [value]="accountGroup">
      <ng-container *ngIf="accountGroup">
        <div matLine>{{ accountGroup.napData.companyName }}</div>
        <ng-container *ngIf="accountGroup.napData.address">
          <div matLine class="address">
            {{ accountGroup.napData.address }}
          </div>
        </ng-container>
      </ng-container>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
